import { ReactComponent as Checked } from './checked.svg';
import { ReactComponent as NotChecked } from './notChecked.svg';

export type CheckboxProps = {
    checked: boolean;
};

export const Checkbox: React.FunctionComponent<CheckboxProps> = ({ checked }) => {
    return checked ? (
        <Checked data-testid="checked" width={30} height={30} />
    ) : (
        <NotChecked data-testid="not-checked" width={30} height={30} />
    );
};
